// Import component translations
import { componentTranslations } from './component-translations';

export type Language = 'en' | 'ro';

export interface TranslationDictionary {
  [key: string]: {
    en: string;
    ro: string;
  };
}

// Main translations dictionary
export const translations: TranslationDictionary = {
  // Common
  'app.name': {
    en: 'Barber Shop',
    ro: 'Frizerie',
  },
  'app.loading': {
    en: 'Loading...',
    ro: 'Se încarcă...',
  },
  'app.error': {
    en: 'An error occurred',
    ro: 'A apărut o eroare',
  },

  // Navigation
  'nav.logo': {
    en: 'Barber Shop',
    ro: 'Salon de Frizerie',
  },
  'nav.home': {
    en: 'Home',
    ro: 'Acasă',
  },
  'nav.book': {
    en: 'Book Appointment',
    ro: 'Programare',
  },
  'nav.bookAppointment': {
    en: 'Book Appointment',
    ro: 'Programează-te',
  },
  'nav.shop': {
    en: 'Shop',
    ro: 'Magazin',
  },
  'nav.dashboard': {
    en: 'Dashboard',
    ro: 'Dashboard',
  },
  'nav.profile': {
    en: 'Profile',
    ro: 'Profil',
  },
  'nav.signin': {
    en: 'Sign In',
    ro: 'Autentificare',
  },
  'nav.signout': {
    en: 'Sign Out',
    ro: 'Deconectare',
  },
  'nav.signIn': {
    en: 'Sign In',
    ro: 'Autentificare',
  },
  'nav.signOut': {
    en: 'Sign Out',
    ro: 'Deconectare',
  },
  'nav.register': {
    en: 'Register',
    ro: 'Înregistrare',
  },
  'nav.language': {
    en: 'Language',
    ro: 'Limbă',
  },
  'nav.services': {
    en: 'Services',
    ro: 'Servicii',
  },

  // Booking Flow
  'booking.title': {
    en: 'Book an Appointment',
    ro: 'Programează o întâlnire',
  },
  'booking.chooseBarber': {
    en: 'Choose a Barber',
    ro: 'Alege un stilist',
  },
  'booking.chooseService': {
    en: 'Select a Service',
    ro: 'Selectează un serviciu',
  },
  'booking.chooseDateAndTime': {
    en: 'Choose Date & Time',
    ro: 'Alege data și ora',
  },
  'booking.confirm': {
    en: 'Confirm Booking',
    ro: 'Confirmă programarea',
  },
  'booking.success': {
    en: 'Booking Confirmed',
    ro: 'Programare confirmată',
  },
  'booking.tryEnhanced': {
    en: 'Try Enhanced Booking Experience',
    ro: 'Încearcă experiența de programare îmbunătățită',
  },

  // Buttons
  'button.select': {
    en: 'Select',
    ro: 'Selectează',
  },
  'button.continue': {
    en: 'Continue',
    ro: 'Continuă',
  },
  'button.back': {
    en: 'Back',
    ro: 'Înapoi',
  },
  'button.cancel': {
    en: 'Cancel',
    ro: 'Anulează',
  },
  'button.save': {
    en: 'Save',
    ro: 'Salvează',
  },
  'button.edit': {
    en: 'Edit',
    ro: 'Editează',
  },
  'button.delete': {
    en: 'Delete',
    ro: 'Șterge',
  },
  'button.confirm': {
    en: 'Confirm',
    ro: 'Confirmă',
  },
  'button.submit': {
    en: 'Submit',
    ro: 'Trimite',
  },
  'button.bookAnother': {
    en: 'Book Another Appointment',
    ro: 'Programează altă întâlnire',
  },
  'button.tryNow': {
    en: 'Try Now',
    ro: 'Încearcă Acum',
  },

  // Profile
  'profile.title': {
    en: 'User Profile',
    ro: 'Profil utilizator',
  },
  'profile.barberTitle': {
    en: 'Barber Profile',
    ro: 'Profil frizer',
  },
  'profile.name': {
    en: 'Name',
    ro: 'Nume',
  },
  'profile.email': {
    en: 'Email',
    ro: 'Email',
  },
  'profile.phone': {
    en: 'Phone',
    ro: 'Telefon',
  },
  'profile.bio': {
    en: 'Bio',
    ro: 'Biografie',
  },
  'profile.bioPlaceholder': {
    en: 'Tell clients about yourself, your specialties, and experience...',
    ro: 'Spune clienților despre tine, specialitățile tale și experiență...',
  },
  'profile.uploadPhoto': {
    en: 'Click the camera icon to upload a profile photo',
    ro: 'Apasă pe iconița de cameră pentru a încărca o fotografie de profil',
  },
  'profile.updateSuccess': {
    en: 'Profile updated successfully',
    ro: 'Profilul a fost actualizat cu succes',
  },

  // Services
  'service.duration': {
    en: 'Duration',
    ro: 'Durată',
  },
  'service.price': {
    en: 'Price',
    ro: 'Preț',
  },
  'service.minutes': {
    en: 'minutes',
    ro: 'minute',
  },

  // Date and Time
  'datetime.selectDate': {
    en: 'Select a Date',
    ro: 'Selectează o dată',
  },
  'datetime.availableTimes': {
    en: 'Available Times',
    ro: 'Ore disponibile',
  },
  'datetime.morning': {
    en: 'Morning',
    ro: 'Dimineață',
  },
  'datetime.afternoon': {
    en: 'Afternoon',
    ro: 'După-amiază',
  },
  'datetime.evening': {
    en: 'Evening',
    ro: 'Seară',
  },
  'datetime.noSlots': {
    en: 'No available time slots for this date.',
    ro: 'Nu există intervale de timp disponibile pentru această dată.',
  },
  'datetime.selectAnother': {
    en: 'Please select another date.',
    ro: 'Te rugăm să selectezi o altă dată.',
  },

  // Confirmation
  'confirm.appointmentDetails': {
    en: 'Appointment Details',
    ro: 'Detalii programare',
  },
  'confirm.serviceDetails': {
    en: 'Service Details',
    ro: 'Detalii serviciu',
  },
  'confirm.date': {
    en: 'Date',
    ro: 'Data',
  },
  'confirm.time': {
    en: 'Time',
    ro: 'Ora',
  },
  'confirm.barber': {
    en: 'Barber',
    ro: 'Frizer',
  },
  'confirm.service': {
    en: 'Service',
    ro: 'Serviciu',
  },
  'confirm.total': {
    en: 'Total',
    ro: 'Total',
  },
  'confirm.ready': {
    en: 'Your appointment is ready to be confirmed',
    ro: 'Programarea ta este gata de confirmare',
  },
  'confirm.processing': {
    en: 'Processing...',
    ro: 'Se procesează...',
  },

  // Success
  'success.title': {
    en: 'Booking Confirmed!',
    ro: 'Programare confirmată!',
  },
  'success.subtitle': {
    en: 'Your appointment has been successfully booked.',
    ro: 'Programarea ta a fost rezervată cu succes.',
  },
  'success.confirmationCode': {
    en: 'Confirmation Code',
    ro: 'Cod de confirmare',
  },
  'success.nextSteps': {
    en: 'Next Steps',
    ro: 'Pașii următori',
  },
  'success.emailSent': {
    en: 'We\'ve sent a confirmation email with all the details of your appointment.',
    ro: 'Am trimis un email de confirmare cu toate detaliile programării tale.',
  },
  'success.arriveEarly': {
    en: 'Please arrive 5-10 minutes before your scheduled time.',
    ro: 'Te rugăm să ajungi cu 5-10 minute înainte de ora programată.',
  },
  'success.copyDetails': {
    en: 'Copy appointment details',
    ro: 'Copiază detaliile programării',
  },
  'success.copied': {
    en: 'Copied to clipboard!',
    ro: 'Copiat în clipboard!',
  },
  'success.createAccount': {
    en: 'Create an account to manage appointments',
    ro: 'Creează un cont pentru a gestiona programările',
  },

  // Auth
  'auth.email': {
    en: 'Email',
    ro: 'Email',
  },
  'auth.password': {
    en: 'Password',
    ro: 'Parolă',
  },
  'auth.userType': {
    en: 'User Type',
    ro: 'Tip utilizator',
  },
  'auth.client': {
    en: 'Client',
    ro: 'Client',
  },
  'auth.barber': {
    en: 'Barber',
    ro: 'Frizer',
  },
  'auth.login': {
    en: 'Login',
    ro: 'Autentificare',
  },
  'auth.register': {
    en: 'Register',
    ro: 'Înregistrare',
  },
  'auth.forgotPassword': {
    en: 'Forgot Password?',
    ro: 'Ai uitat parola?',
  },
  'auth.noAccount': {
    en: 'Don\'t have an account?',
    ro: 'Nu ai un cont?',
  },
  'auth.haveAccount': {
    en: 'Already have an account?',
    ro: 'Ai deja un cont?',
  },
  'auth.errors.timeout': {
    en: 'Request timed out. Please try again.',
    ro: 'Cererea a expirat. Te rugăm să încerci din nou.',
  },
  'auth.errors.invalid': {
    en: 'Invalid email or password',
    ro: 'Email sau parolă invalidă',
  },
  'auth.loggingIn': {
    en: 'Logging in...',
    ro: 'Se autentifică...',
  },

  // Merge component translations
  ...componentTranslations,
}; 